import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import LuxPlusBenefitIcon from './LuxPlusBenefitIcon'
import useEnabledLuxPlusBenefits from 'luxPlus/hooks/useEnabledLuxPlusBenefits'
import groupLuxPlusBenefits from 'luxPlus/lib/groupLuxPlusBenefits'

interface Props {
  /**
   * Whether to use the longer or shorter version of the benefit title.
   */
  kind: 'long' | 'short'
  benefits: Array<App.OfferSubscriptionBenefitItem>
  /**
   * When true, partner_promo_code and discounted_* benefits are collapsed
   * into grouped entries with combined copy.
   */
  grouped?: boolean
}

function LuxPlusBenefitsList(props: Props) {
  const { kind = 'long', benefits, grouped = false } = props
  const intl = useIntl()
  const enabledBenefits = useEnabledLuxPlusBenefits(benefits)

  const benefitViewItems: Array<App.LuxPlusBenefitView> = useMemo(
    () => grouped ? groupLuxPlusBenefits(enabledBenefits, intl) : enabledBenefits,
    [enabledBenefits, grouped, intl],
  )

  return (
    <>
      {benefitViewItems.map(benefit => <BodyTextBlock
        key={benefit.type}
        variant="medium"
        startIcon={<LuxPlusBenefitIcon colour="lux-plus" benefit={benefit} />}
      >
        {kind === 'long' && benefit.title}
        {kind === 'short' && benefit.shortTitle}
      </BodyTextBlock>)}
    </>
  )
}

export default LuxPlusBenefitsList
